import { CSSProperties } from "@mui/styles/withStyles";
import { Add } from "@mui/icons-material";
import { Typography, Button } from "@mui/material";
import { Token } from "../../theme";

/**
 * The toolbar the table renders above itself. The buttons are portalled next to the page title by
 * useToolbarActions, so this wrapper is left with nothing to show.
 */
export const customButtonsContainer: CSSProperties = {
  display: "none",
};

export const gridButtonContainer: CSSProperties = {};

// Custom button builder function
export const customButtonBuilder = (onClick: () => void, style?: CSSProperties) => (
  // @ts-ignore
  <Button
    type="submit"
    startIcon={<Add />}
    color="primary"
    sx={{
      color: Token.textOnAction,
      backgroundColor: Token.actionPrimary,
      "&:hover": {
        backgroundColor: Token.actionPrimaryHover,
      },
    }}
    onClick={onClick}
  >
    <Typography variant="body1">Add</Typography>
  </Button>
);
